import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import Skeleton from 'components/shared/Skeleton';
import { EventDayType } from 'sdk/hooks/events/useEventCalendar';
import styles from './CalendarItem.module.scss';

export type CalendarItemType = {
  data?: EventDayType,
  date?: string,
  skeleton?: boolean,
  activeLink?: string,
}

function CalendarItem({
  data, date, skeleton, activeLink,
}: CalendarItemType) {
  const navigate = useNavigate()

  if (skeleton) {
    return (
      <Skeleton className={clsx(styles.calendarItem, styles.calendarItemSkeleton)}>
        <Skeleton className={styles.date} style={{ width: '50%' }} />
      </Skeleton>
    )
  }

  return (
    <div
      className={clsx(
        styles.calendarItem,
        data?.date === date && styles.calendarItemActive,
      )}
    >
      <div className={styles.date} onClick={() => navigate(`/events?date=${data?.date}`)}>{data?.dateCaption}</div>
      <div className={styles.tags}>
        {(
          data?.earnings
          && (activeLink === '/events' || activeLink === '/events/earnings')
        ) ? (
          <Link
            className={clsx(styles.tag, styles.tagEarnings)}
            to={`/events/earnings?date=${data?.date}`}
          >
            Earnings
            {' '}
            {data?.earnings}
          </Link>
          ) : null}
        {(
          data?.stockSplits
          && (activeLink === '/events' || activeLink === '/events/stock-splits')
        ) ? (
          <Link
            className={clsx(styles.tag, styles.tagStockSplits)}
            to={`/events/stock-splits?date=${data?.date}`}
          >
            Stock Splits
            {' '}
            {data?.stockSplits}
          </Link>
          ) : null}
        {(
          data?.ipos
          && (activeLink === '/events' || activeLink === '/events/ipos')
        ) ? (
          <Link
            className={clsx(styles.tag, styles.tagIpos)}
            to={`/events/ipos?date=${data?.date}`}
          >
            IPOs
            {' '}
            {data?.ipos}
          </Link>
          ) : null}
        {(
          data?.economicEvents
          && (activeLink === '/events' || activeLink === '/events/economic-events')
        ) ? (
          <Link
            className={clsx(styles.tag, styles.tagEconomicEvents)}
            to={`/events/economic-events?date=${data?.date}`}
          >
            Economic Events
            {' '}
            {data?.economicEvents}
          </Link>
          ) : null}
      </div>
    </div>
  );
}

export default CalendarItem;
